import { Paper } from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { addContratista, addEmpresa, addPuestoAsociado, addSustancia, addTrabajador, clearRes, postCabecera, postObservaciones } from "../../../redux/actions/resolucion";
import Breadcrumb from "../../commons/breadcrumb/Breadcrumb";
import ConfirmDialog from "../../commons/dialog/ConfirmDialog";
import DataLabel from "../../commons/labels/DataLabel";
import HeaderForm from "../../commons/labels/HeaderForm";
import { StyledResolucion } from "../../styled/Prevencion";
import CabeceraContainer from "./cabecera/CabeceraContainer";
import ContratistasYEmpresasContainer from "./contratistas/ContratistasYEmpresasContainer";
import EstablecimientoContainer from "./establecimiento/EstablecimientoContainer";
import ObservacionesContainer from "./observaciones/ObservacionesContainer";
import PuestosAsociadosContainer from "./puestos/PuestosAsociadosContainer";
import SustanciasContainer from "./sustancias/SustanciasContainer";
import TrabajadoresSectorContainer from "./trabajadores/TrabajadoresSectorContainer";

const ResolucionContainer = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const datosEstablecimiento = useSelector(
    (state) => state.resolucion.datosEstablecimiento
  );
  const [form, setForm] = useState("Establecimiento");
  const [fromBread, setFromBread] = useState(false);
  const [breadcrumbFields, setBreadcrumbFields] = useState([form]);
  const [openDialog, setOpenDialog] = useState(false);

  const mapFormValues = (data) => {
    if (data?.value?.data) {
      const dataPlaceholder = data.value.data;
      // Cabecera
      dispatch(postCabecera({
        cantidadTrabajadoresProduccion: dataPlaceholder.totalTrabajadoresProduccion,
        cantidadTrabajadoresEventualesProduccion: dataPlaceholder.totalTrabajadoresProduccionEventuales,
        cantidadTrabajadoresAdministracion: dataPlaceholder.totalTrabajadoresAdministracion,
        cantidadTrabajadoresEventualesAdministracion: dataPlaceholder.totalTrabajadoresAdministracionEventuales,
        sePuedeFumar: dataPlaceholder.permiteFumar,
        espacioParaFumar: dataPlaceholder.poseeEspacioFumador,
        contacto: dataPlaceholder.idContactoEmpresa,
        responsableEmpresa: dataPlaceholder.idResponsableEmpresa,
        responsableMedicina: dataPlaceholder.idResponsableEmpresaML,
        responsableSH: dataPlaceholder.idResponsableEmpresaSH,
        idEstablecimientoDeclaradoSRT: dataPlaceholder.idEstablecimientoDeclaradoSRT,
      }))
      // Observaciones:
      dispatch(postObservaciones({
        observacionesGenerales: dataPlaceholder.observacionesGenerales,
        descripcionActividadEstablecimiento: dataPlaceholder.descripcionActividad,
      }));

      // Sustancias y puestos:
      dataPlaceholder.sustancias.forEach((sustancia) => {
        let usos = sustancia.utilizaciones ? sustancia.utilizaciones.map((uso) => ({
          idPrevForm: uso.id,
          usos: uso.idUsoOrigen,
          modoEmpleo: uso.idModoEmpleo,
          nombreUso: uso.descripcionUsoOrigen,
          nombreModoEmpleo: uso.descripcionModoEmpleo,
          codigoSRT: uso.codigoSRT,
        }))
          : [];
        let estudios = sustancia.estudios ? sustancia.estudios.map((estudio) => {
          return {
            idPrevForm: estudio.id,
            idTipoEstudio: estudio.idTipoEstudio,
            numeroFrecuencia: estudio.cantidadFrecuencia,
            frecuenciaEstudio: estudio.idFrecuenciaEstudio,
            idMetodologiaEmpleada: estudio.idMetodologiaEmpleada,
            nombreTiposEstudio: estudio.descripcionTipoEstudio,
            nombreMetodologiaEmpleada: estudio.descripcionMetodologiaEmpleada,
            codigoSRT: estudio.codigoSRT,
          }
        })
          : [];

        let proveedores = sustancia.proveedoresCompradores ? sustancia.proveedoresCompradores.map((proveedores) => {
          return {
            idPrevForm: proveedores.id,
            razonSocial: proveedores.razonSocial,
            cuit: proveedores.cuit,
            esComprador: proveedores.esComprador,
            pais: proveedores.pais,
            provincia: proveedores.provincia?.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
              letter.toUpperCase()),
            localidad: proveedores.localidad?.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, (letter) =>
              letter.toUpperCase()),
            calle: proveedores.calle,
            km: proveedores.sinNro,
            numero: proveedores.nro,
            departamento: proveedores.departamento,
            piso: proveedores.piso,
            codigoPostal: proveedores.codigoPostal,
            codigoSRT: proveedores.codigoSRT,
          }
        }) : [];
        let equiposRadiologicos = sustancia.equiposRadiologicos ? sustancia.equiposRadiologicos.map((equipoRadiologico) => {
          return {
            equipoRadiologicoData: {
              idPrevForm: equipoRadiologico.id,
              id: equipoRadiologico.equipoRadiologicoEstablecimiento.id,
              idEquipoRadiologicoSRT: equipoRadiologico.idEquipoRadiologicoSRT,
              idDependenciaEmpleador: equipoRadiologico.equipoRadiologicoEstablecimiento
                .idDependenciaEmpleador,
              idTipoEquipoRadiologico: equipoRadiologico.equipoRadiologicoEstablecimiento
                .idTipoEquipoRadiologico,
              nombreTipoEquipoRadiologico: equipoRadiologico.equipoRadiologicoEstablecimiento
                .nombreTipoEquipoRadiologico,
              idCaracteristicaEquipoRadiologico: equipoRadiologico.equipoRadiologicoEstablecimiento
                .idCaracteristicaEquipoRadiologico,
              nombreCaracteristicaEquipoRadiologico: equipoRadiologico.equipoRadiologicoEstablecimiento
                .nombreCaracteristicaEquipoRadiologico,
              idTipoRadiacion: equipoRadiologico.equipoRadiologicoEstablecimiento
                .idTipoRadiacion,
              nombreTipoRadiacion: equipoRadiologico.equipoRadiologicoEstablecimiento
                .nombreTipoRadiacion,
              idTipoFuente: equipoRadiologico.equipoRadiologicoEstablecimiento
                .idTipoFuente,
              nombreTipoFuente: equipoRadiologico.equipoRadiologicoEstablecimiento
                .nombreTipoFuente,
              idTipoMetodoProcesamientoImagen: equipoRadiologico.equipoRadiologicoEstablecimiento
                .idTipoMetodoProcesamientoImagen,
              nombreTipoMetodoProcesamientoImagen: equipoRadiologico.equipoRadiologicoEstablecimiento
                .nombreTipoMetodoProcesamientoImagen,
              marca: equipoRadiologico.equipoRadiologicoEstablecimiento
                .marca,
              modelo: equipoRadiologico.equipoRadiologicoEstablecimiento
                .modelo,
              actividad: equipoRadiologico.equipoRadiologicoEstablecimiento
                .actividad,
              radioisotipoFuente: equipoRadiologico.equipoRadiologicoEstablecimiento
                .radioisotipoFuente,
              potenciaEquipoKVP: equipoRadiologico.equipoRadiologicoEstablecimiento
                .potenciaEquipoKVP,
              potenciaEquipomAp: equipoRadiologico.equipoRadiologicoEstablecimiento
                .potenciaEquipomAp,
              potenciaEquipoMeV: equipoRadiologico.equipoRadiologicoEstablecimiento
                .potenciaEquipoMeV,
              procesamientoImagenes: equipoRadiologico.equipoRadiologicoEstablecimiento
                .procesamientoImagenes,
              observaciones: equipoRadiologico.equipoRadiologicoEstablecimiento
                .observaciones,
            },
            dosimetria: equipoRadiologico.dosimetrias ? equipoRadiologico.dosimetrias.map((dosimetria) => ({
              idPrevForm: dosimetria.id,
              tipoDosimetria: dosimetria.idTipoDosimetria,
              metodoDosimetria: dosimetria.idMetodoDosimetria,
              cantidadPersonal: dosimetria.cantidadPersonal,
              cuitResponsable: dosimetria.cuitResponsable,
              nombreMetodoDosimetria: dosimetria.nombreMetodoDosimetria,
              nombreTipoDosimetria: dosimetria.nombreTipoDosimetria,
              codigoSRT: dosimetria.codigoSRT,
            })) : [],
            respUso: equipoRadiologico.responsablesUso ? equipoRadiologico.responsablesUso.map((responsable) => ({
              idPrevForm: responsable.id,
              cuitResponsable: responsable.cuitResponsable,
              numeroAutorizacionIndividual: responsable.numeroAutorizacionIndividual,
              numeroPermisoHabilitante: responsable.numeroPermisoHabilitante,
              matriculaProfesional: responsable.matriculaProfesional,
              fechaExpedicion: responsable.fechaExpedicion,
              fechaVencimiento: responsable.fechaVencimiento,
              licenciaEspecial: responsable.licenciaEspecial,
              codigoSRT: responsable.codigoSRT,
            })) : [],
            respInst: equipoRadiologico.responsablesInstalacion ? equipoRadiologico.responsablesInstalacion.map((responsable) => ({
              idPrevForm: responsable.id,
              cuitResponsable: responsable.cuitResponsable,
              numeroLicenciaHabilitante: responsable.numeroLicenciaHabilitante,
              domicilioHabilitacion: responsable.domicilioHabilitacion,
              fechaExpedicion: responsable.fechaExpedicion,
              fechaVencimiento: responsable.fechaVencimiento,
              codigoSRT: responsable.codigoSRT,
            })) : [],
            protRad: equipoRadiologico.encargadosProteccion ? equipoRadiologico.encargadosProteccion.map((responsable) => ({
              idPrevForm: responsable.id,
              cuitResponsable: responsable.cuitResponsable,
              matriculaProfesional: responsable.matriculaProfesional,
              tituloProfesional: responsable.tituloProfesional,
              numeroHabilitacion: responsable.numeroHabilitacion,
              codigoSRT: responsable.codigoSRT,
            })) : [],
          }

        }) : [];

        let objetoSustancia = {
          sustancia: {
            cantidad: sustancia.cantidad.toString().replace(".", ","),
            nombre: sustancia.nombreComercial,
            unidad: sustancia.idUnidadMedida,
            sustancia: sustancia.idAgenteCancerigeno,
            nombreAgente: sustancia.descripcionAgenteCancerigeno,
            descripcionAgente: sustancia.codigoAgenteCancerigeno,
          },
          idPrevForm: sustancia.id,
          id: sustancia.id,
          codigoSRT: sustancia.codigoSRT,
          equiposRadiologicos,
          proveedores,
          estudios,
          usos,

        };

        dispatch(addSustancia(objetoSustancia));

        sustancia.puestos?.forEach((p) => {
          let puesto = {
            idPrevForm: p.id,
            sustancia: sustancia.id,
            nombrePuesto: p.nombrePuestoEstablecimiento,
            puesto: p.idPuestoEstablecimiento,
            descripcionActividades: p.descripcion,
            descripcionEstudios: p.descripcionEstudios,
            informaRiesgos: p.informaSobreRiesgos,
            poseeCapacitaciones: p.capacitacionSobreRiesgos,
            entregaProteccion: p.entregaElementosDeProteccion,
            licenciasEspeciales: p.licenciaEspecial,
            elementosDeProteccion:
              p.elementosProteccionPersonal ? p.elementosProteccionPersonal.map((elementoDeProteccion) => ({
                idPrevForm: elementoDeProteccion.id,
                idElementoDeProteccion: elementoDeProteccion.idElementoProteccionPersonal,
              })) : [],
            medidasPreventivas:
              p.medidasPreventivas ? p.medidasPreventivas?.map((medidaPreventiva) => ({
                idPrevForm: medidaPreventiva.id,
                idMedidaPreventiva: medidaPreventiva.idMedidaPreventivaCancerigenos,
              })) : [],
            codigoSRT: p.codigoSRT,
          }
          dispatch(addPuestoAsociado(puesto));
        });

      })
      // Trabajadores:
      dataPlaceholder.trabajadores?.forEach((trabajador) => {
        let nuevoTrabajador = {
          idPrevForm: trabajador.id,
          cuil: trabajador.cuitNomina,
          nombreApellidoTrabajador: trabajador.nombreCompletoNomina,
          nombreSector: trabajador.nombreSectorEstablecimiento,
          nombrePuesto: trabajador.nombrePuestoEstablecimiento,
          idPuesto: trabajador.idPuestoEstablecimiento,
          idSector: trabajador.idSectorEstablecimiento,
          fechaIngreso: trabajador.fechaIngresoEmpresa,
          inicioContacto: trabajador.fechaInicioContacto,
          finContacto: trabajador.fechaFinContacto,
          exposicion: trabajador.sinExposicion,
          sustanciasAsociadasAPuesto: [],
          examenes: {},
          idTrabajador: trabajador.idNomina,
          permanente: trabajador.permanente,
          codigoSRT: trabajador.codigoSRT,
          codigoActividadSRT: trabajador.codigoActividadSRT,
        }
        // Asignar examenes
        trabajador.examenesMedicos?.forEach((examen) => {
          if (!nuevoTrabajador.examenes?.[examen.idSustancia]) {
            nuevoTrabajador.examenes[examen.idSustancia] = {
              [examen.idTipoExamenMedico]: {
                idPrevForm: examen.id,
                value: true,
                idExamenDeclaradoSRT: examen.idExamenDeclaradoSRT
              },
            }
          } else {
            nuevoTrabajador.examenes[examen.idSustancia][examen.idTipoExamenMedico] = {
              idPrevForm: examen.id,
              value: true,
              idExamenDeclaradoSRT: examen.idExamenDeclaradoSRT
            };
          }
        });
        dispatch(addTrabajador(nuevoTrabajador))
      });
      // Contratistas
      dataPlaceholder.contratistas?.forEach((contratista, index) => {
        dispatch(addContratista({
          idPrevForm: contratista.id,
          id: index,
          cuit: contratista.cuit,
          ciiu: contratista.actividad,
          cantidadEmpleados: contratista.cantidadTrabajadores,
          idContratistaSRT: contratista.idContratistaSRT,
        }))
      })
      // Empresas
      dataPlaceholder.empresasTercerizadas?.forEach((contratista, index) => {
        dispatch(addEmpresa({
          idPrevForm: contratista.id,
          id: index,
          cuit: contratista.cuit,
          ciiu: contratista.actividad,
          cantidadEmpleados: contratista.cantidadTrabajadores,
          idEmpresaSRT: contratista.idEmpresaSRT,
        }))
      })
    }
  }

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const handleConfirmCancel = () => {
    if (!state?.idDependenciaEmpleador) {
      dispatch(clearRes());
      setForm("Establecimiento");
      setBreadcrumbFields(["Establecimiento"]);
      setOpenDialog(false);
    } else {
      dispatch(clearRes());
      setOpenDialog(false);
      navigate(`/prevencion/establecimientos/${state?.idDependenciaEmpleador}`, {
        state: {
          ...datosEstablecimiento.data,
          idDependenciaEmpleador: state?.idDependenciaEmpleador,
        },
      });
    }

  };

  const handleSetForm = (form) => {
    if (!breadcrumbFields.includes(form)) {
      const auxArray = [...breadcrumbFields, form];
      setBreadcrumbFields(auxArray);
    }
    setForm(form);
  };

  return (
    <>
      <Paper style={{ overflowX: "hidden" }}>
        <HeaderForm title={"Formulario Res. 81/19"} />
        <StyledResolucion.BreadcrumbContainer>
          <Breadcrumb
            setForm={setForm}
            setFields={setBreadcrumbFields}
            fields={breadcrumbFields}
            setFromBread={() => setFromBread(true)}
            form={form}
          />
        </StyledResolucion.BreadcrumbContainer>
        {form !== "Establecimiento" && (
          <StyledResolucion.FormsContainer>
            <DataLabel
              firstText={"MU: " + datosEstablecimiento.data?.matrizUnica}
              secondText={datosEstablecimiento.data?.nombre?.split("-")[0]}
              thirdText={datosEstablecimiento.data?.domicilio}
            />
          </StyledResolucion.FormsContainer>
        )}
        {
          {
            Establecimiento: (
              <EstablecimientoContainer
                nextForm={handleSetForm}
                fromBread={fromBread}
                mapFormValues={mapFormValues}
                handleCancelResolucion={handleOpenDialog}
              />
            ),
            Cabecera: (
              <CabeceraContainer
                nextForm={handleSetForm}
                handleCancelResolucion={handleOpenDialog}
                establecimiento={datosEstablecimiento.data}
              />
            ),
            Observaciones: (
              <ObservacionesContainer
                nextForm={handleSetForm}
                handleCancelResolucion={handleOpenDialog}
                establecimiento={datosEstablecimiento.data}
              />
            ),
            Sustancias: (
              <SustanciasContainer
                nextForm={handleSetForm}
                handleCancelResolucion={handleOpenDialog}
                establecimiento={datosEstablecimiento.data}
              />
            ),
            PuestosAsociados: (
              <PuestosAsociadosContainer
                handleCancelResolucion={handleOpenDialog}
                nextForm={handleSetForm}
                establecimiento={datosEstablecimiento.data}
              />
            ),
            TrabajadoresSector: (
              <TrabajadoresSectorContainer
                nextForm={handleSetForm}
                handleCancelResolucion={handleOpenDialog}
              />
            ),
            ContratistasYEmpresas: (
              <ContratistasYEmpresasContainer nextForm={handleSetForm} />
            ),
          }[form]
        }
      </Paper>
      <ConfirmDialog
        open={openDialog}
        handleClose={handleCloseDialog}
        handleConfirm={handleConfirmCancel}
        loading={false}
        title="Cancelar"
        text="¿Está seguro de que desea cancelar? Toda la carga realizada en el formulario no se guardará"
      />
    </>
  );
};

export default ResolucionContainer;
